import React, {useMemo} from 'react';

import {AuditFilterAction} from 'audit/AuditDAO';

import AuditLogFilterDropdown from './AuditLogFilterDropdown';
import AuditLogMultiSelectFilterDropdownContent, {
  AuditLogFilterOption,
} from './AuditLogMultiSelectFilterDropdown';

export interface AuditLogActionFilterDropdownProps {
  actions: Array<AuditFilterAction>;
  selectedActionValues: Array<string>;
  onChange: (selectedActionValues: Array<string>) => void;
  disabled?: boolean;
}

function actionToOption(action: AuditFilterAction): AuditLogFilterOption {
  return {
    value: action.display_name,
    label: action.display_name,
  };
}

const LABEL = 'Action';

export default function AuditLogActionFilterDropdown(props: AuditLogActionFilterDropdownProps): JSX.Element {
  const {actions, selectedActionValues, onChange, disabled} = props;
  const options = useMemo(() => actions.map((a) => actionToOption(a)), [actions]);

  return (
    <AuditLogFilterDropdown
      label={LABEL}
      count={selectedActionValues.length}
      disabled={disabled}
      content={
        <AuditLogMultiSelectFilterDropdownContent<AuditLogFilterOption>
          options={options}
          selectedValues={selectedActionValues}
          onChange={onChange}
        />
      }
    />
  );
}
